import React, { PureComponent } from 'react'
import { string, func, shape } from 'prop-types'
import appendQuery from 'append-query'
import Button from '@active/react-ui/Button'
import Form from '@active/react-ui/Form'
import RadioGroup from '@active/react-ui/RadioGroup'
import Radio from '@active/react-ui/Radio'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'

import Responsive from '@active/react-utils/components/Responsive'
import I18nMessage from '../common/I18nMessage'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import CommonError from '../common/CommonError'
import './parentsVerification.scss'
import connectLocale from '../../shared/utils/connectLocale'

class ParentsVerification extends PureComponent {
  static propTypes = {
    locale: string.isRequired,
    services: shape({
      verify: func.isRequired,
      preVerify: func.isRequired,
    }).isRequired,
    configureTrack: func.isRequired,
    pendingKey: string.isRequired,
  }

  constructor(props) {
    super(props)

    const formFields = {
      grantActive: '',
      grantThirdParty: '',
    }

    this.state = {
      formFields,
      isVerifySuccess: false,
      errMsg: '',
      isGrantThirdPartyDisable: false,
      isBtnDisable: false,
      showError: false,
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'COPPAVerification',
      widget: 'create_account',
      pageType: 'COPPA',
    })

    this.verification()
  }

  verification = () => {
    const { services, pendingKey } = this.props
    services.preVerify({
      params: { pendingKey },
      resolve: ({ status, message }) => {
        if (status === 'SUCCESS') {
          this.setState({
            isVerifySuccess: true,
          })
        } else {
          this.setState({
            showError: true,
            errMsg: message,
          })
        }
      },
      reject: ({ message }) => {
        this.setState({
          showError: true,
          errMsg: message || '',
        })
      },
    })
  }

  handleGrantActiveChange = e => {
    const { value } = e.target

    const { formFields } = this.state

    if (value === 'false') {
      this.setState({
        isGrantThirdPartyDisable: true,
        formFields: {
          grantActive: value,
          grantThirdParty: '',
        },
        isBtnDisable: false,
        showError: false,
        errMsg: '',
      })
    } else {
      this.setState({
        isGrantThirdPartyDisable: false,
        formFields: {
          ...formFields,
          grantActive: value,
        },
        isBtnDisable: false,
        showError: false,
        errMsg: '',
      })
    }
  }

  handleGrantThirdPartyChange = e => {
    const { value } = e.target
    const { formFields } = this.state
    this.setState({
      formFields: {
        ...formFields,
        grantThirdParty: value,
      },
      isBtnDisable: false,
      showError: false,
      errMsg: '',
    })
  }

  handleSubmit = () => {
    const { services, pendingKey, locale } = this.props
    const { formFields: { grantActive, grantThirdParty }, isGrantThirdPartyDisable } = this.state
    if (!grantActive || (!grantThirdParty && !isGrantThirdPartyDisable)) {
      this.setState({
        showError: true,
        errMsg: 'passport.coppa.text.pleaseSelect',
      })
    } else {
      this.setState({
        errMsg: '',
        showError: false,
        isBtnDisable: true,
      })
      services.verify({
        params: {
          grantActive,
          grantThirdParty: isGrantThirdPartyDisable ? 'false' : grantThirdParty,
          pendingKey,
        },
        resolve: ({ succeed, data, message }) => {
          if (succeed === 'true') {
            window.location.href = appendQuery(data.nextUrl, { locale })
          } else {
            this.setState({
              showError: true,
              errMsg: message,
            })
          }
        },
        reject: ({ message }) => {
          this.setState({
            showError: true,
            errMsg: message || '',
          })
        },
      })
    }
  }

  renderTopGridItem = () => {
    const {
      isGrantThirdPartyDisable,
      isBtnDisable,
      formFields,
      errMsg,
      showError,
    } = this.state

    return (
      <>
        <div className="coppa__title">
          <I18nMessage id="passport.coppa.text.coppa" />
        </div>
        <hr />
        <CommonError showError={showError} errMsg={errMsg} />
        <div className="coppa__content">
          <div className="coppa__item">
            <I18nMessage id="passport.coppa.text.toComply" />
          </div>
          <div>
            <I18nMessage id="passport.coppa.text.pleaseReview" />
          </div>
          <div className="coppa__sub-title">
            <I18nMessage id="passport.coppa.text.basic" />
          </div>
          <div>
            <I18nMessage id="passport.coppa.text.thisLevel" />
          </div>
          <div className="coppa__content__wrapper">
            <ul>
              <li>
                <I18nMessage id="passport.coppa.text.name" />
              </li>
              <li>
                <I18nMessage id="passport.coppa.text.email" />
              </li>
              <li>
                <I18nMessage id="passport.coppa.text.parentEmai" />
              </li>
              <li>
                <I18nMessage id="passport.coppa.text.dob" />
              </li>
              <li>
                <I18nMessage id="passport.coppa.text.permission" />
              </li>
            </ul>
            <div className="coppa__option">
              <div className="coppa__bold-content">
                <I18nMessage id="passport.coppa.text.provide" />
              </div>
              <RadioGroup
                name="grantActive"
                onChange={this.handleGrantActiveChange}
                value={formFields.grantActive}
              >
                <Radio value="true">
                  <I18nMessage id="passport.coppa.text.provideBasic" />
                </Radio>
                <Radio value="false" className="no-pt">
                  <I18nMessage id="passport.coppa.text.decline" />
                </Radio>
              </RadioGroup>
            </div>
            <hr className="path-2" />
            <div className="coppa__sub-title">
              <I18nMessage id="passport.coppa.text.permissionTo" />
            </div>
            <div className="coppa__option">
              <div className="coppa__bold-content">
                <I18nMessage id="passport.coppa.text.iProvide" />
              </div>
              <RadioGroup
                disabled={isGrantThirdPartyDisable}
                name="grantThirdParty"
                onChange={this.handleGrantThirdPartyChange}
                value={formFields.grantThirdParty}
              >
                <Radio value="true">
                  <I18nMessage id="passport.coppa.text.providePermissions" />
                </Radio>
                <Radio value="false" className="no-pt">
                  <I18nMessage id="passport.coppa.text.declinePermissions" />
                </Radio>
              </RadioGroup>
            </div>
            <hr className="path-2" />
          </div>
          <div className="coppa__item">
            <I18nMessage id="passport.coppa.text.after" />
          </div>
          <div>
            <I18nMessage id="passport.coppa.text.youCan" />
            <a href="http://activesupport.force.com/usersupport" target="_blank" rel="noreferrer">
              <I18nMessage id="passport.coppa.text.support" />
            </a>
            <I18nMessage id="passport.coppa.text.anyTime" />
          </div>
        </div>
        <Button
          type="super"
          submit
          disabled={isBtnDisable}
          className="coppa__btn"
        >
          <I18nMessage id="passport.coppa.btn.submit" />
        </Button>
      </>
    )
  }

  render() {
    const {
      isVerifySuccess,
      errMsg,
      showError,
    } = this.state
    return (
      <DefaultComponentLayout nameSpace="passport__parents-verification">
        <LayoutContent main>
          {isVerifySuccess ? (
            <Form
              onSubmit={this.handleSubmit}
              enableReinitialize
            >
              <Grid fluid justify="center">
                <Responsive eqAbove="md">
                  <GridItem
                    span={8}
                    className="passport__pl25 passport__pr25"
                  >
                    {this.renderTopGridItem()}
                  </GridItem>
                </Responsive>
                <Responsive eqAbove="md" not>
                  <GridItem
                    className="passport__pl25 passport__pr25"
                  >
                    {this.renderTopGridItem()}
                  </GridItem>
                </Responsive>
                <GridItem
                  spanSm={4}
                  className="coppa__side-bar"
                >
                  <div className="coppa__sub-title">
                    <I18nMessage id="passport.coppa.text.questions" />
                  </div>
                  <div className="coppa__bold-content">
                    <I18nMessage id="passport.coppa.text.why" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.during" />
                  </div>
                  <div className="coppa__bold-content passport__pt40">
                    <I18nMessage id="passport.coppa.text.canI" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.weAllow" />
                    <a href="http://activesupport.force.com/usersupport" target="_blank" rel="noreferrer">
                      <I18nMessage id="passport.coppa.text.support" />
                    </a>
                  </div>
                  <div className="coppa__bold-content passport__pt40">
                    <I18nMessage id="passport.coppa.text.whenWill" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.whenYour" />
                  </div>
                  <div className="coppa__bold-content passport__pt40">
                    <I18nMessage id="passport.coppa.text.howCanI" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.visit" />
                    <a href="http://www.coppa.org" target="_blank" rel="noreferrer">
                      <I18nMessage id="passport.coppa.text.coppaOrg" />
                    </a>
                    <I18nMessage id="passport.coppa.text.forMore" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.visit" />
                    <a href="https://www.eugdpr.org/" target="_blank" rel="noreferrer">
                      <I18nMessage id="passport.coppa.text.gdprOrg" />
                    </a>
                    <I18nMessage id="passport.coppa.text.forMore" />
                  </div>
                  <div>
                    <I18nMessage id="passport.coppa.text.activePrivacyPolicy" />
                  </div>
                </GridItem>
              </Grid>
              <Grid fluid justify="start">
                <GridItem span={12} />
              </Grid>
            </Form>
          ) : (
            <CommonError showError={showError} errMsg={errMsg} />
          )}
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default connectLocale(ParentsVerification)
